import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiChevronLeft, FiCopy, FiClock } from 'react-icons/fi';
import { ROUTES } from '../../app/routes';
import PolicyComparisonUpload from './PolicyComparisonUpload';
import PolicyComparisonHistory from './PolicyComparisonHistory';
import '../commissionscan/CommissionScan.css';
import './PolicyComparison.css';
const PolicyComparisonPage: React.FC = () => {
    const navigate = useNavigate();
    const [view, setView] = useState<'new' | 'history'>('new');
    return (<div className="cs-page">
      
      <div className="cs-sidebar">
        <button className="cs-back-link" onClick={() => navigate(ROUTES.MARKETPLACE)}>
          <FiChevronLeft size={14}/>
          Back to Marketplace
        </button>
        <nav className="cs-nav">
          <button className={`cs-nav__item${view === 'new' ? ' cs-nav__item--active' : ''}`} onClick={() => setView('new')}>
            <FiCopy size={15}/>
            New Comparison
          </button>
          <button className={`cs-nav__item${view === 'history' ? ' cs-nav__item--active' : ''}`} onClick={() => setView('history')}>
            <FiClock size={15}/>
            History
          </button>
        </nav>
      </div>

      
      <div className={`cs-main${view === 'history' ? ' cs-main--history' : ''}`}>
        {view === 'history' ? (<PolicyComparisonHistory />) : (<PolicyComparisonUpload onGoToHistory={() => setView('history')}/>)}
      </div>
    </div>);
};
export default PolicyComparisonPage;
